import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import mapImports from "@xe/util-webpack-context";

var svgContext = require.context("../svgs", false, /\.svg$/);

export var nameToSvg = mapImports(svgContext, function (str) {
  return str.replace(/\.\/icon-|\.svg/g, "");
});

var Icon = function Icon(_ref) {
  var _theme$icon;

  var color = _ref.color,
      component = _ref.component,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "component", "name"]);

  var Svg = component || nameToSvg[name];
  var theme = useContext(ThemeContext);

  if (!Svg) {
    console.error("Icon: You must pass a valid string through the `name` prop or an SVG component " + "through the `component` prop; you cannot leave both props undefined.");
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement(Svg, _extends({
      color: color || (theme == null ? void 0 : (_theme$icon = theme.icon) == null ? void 0 : _theme$icon.fill) || "currentColor"
    }, rest))
  );
};

Icon.propTypes = {
  color: PropTypes.string,
  component: PropTypes.elementType,
  name: PropTypes.oneOf(Object.keys(nameToSvg))
};
export default Icon;